module.exports = __webpack_public_path__ + "static/img/logoIcon.34e6df55.svg";